export const Message = {
  kcellBusiness: {
    ru: "Kcell Бизнес",
    en: "Kcell Business",
    kk: "Kcell Бизнес",
  },
  selectCompany: {
    ru: "Выбор компании",
    en: "Select company",
    kk: "Компания таңдау",
  },
  selectLang: {
    ru: "Выбор языка",
    en: "Choose lang",
    kk: "Тілді таңдау",
  },
  chooseService: {
    ru: "Выбор услуги",
    en: "Choose service",
    kk: "Қызметті таңдау",
  },
  myProfile: {
    ru: "Мой профиль",
    en: "My profile",
    kk: "Менің профилім",
  },
  myCompanies: {
    ru: "Мои компании",
    en: "My companies",
    kk: "Менің компанияларым",
  },
  exit: {
    ru: "Выйти",
    en: "Exit",
    kk: "Шығу",
  },
  paymentTerms: {
    ru: "Информация для оплаты",
    en: "Payment terms",
    kk: "Төлем ақпараты",
  },
  eRegister: {
    ru: "Электронный реестр",
    en: "E-register",
    kk: "Электрондық тізім",
  },
  applicationSamples: {
    ru: "Образцы заявлений",
    en: "Applications samples",
    kk: "Өтініш үлгілері",
  },
  contacts: {
    ru: "Контакты",
    en: "Contacts",
    kk: "Байланыстар",
  },
  footerText: {
    ru:
      " © АО Kcell 2000-2017. Государственная лицензия № ДС0000270 от 08.06.1998, " +
      "бессрочная, выдана Министерством транспорта и коммуникаций Республики Казахстан",
    en:
      "© Kcell JSC 2000–2017. State license No. ДС0000270 of 08.06.1998, perpetual," +
      "issued by the Ministry of Transport and Communications of the Republic of Kazakhstan.",
    kk:
      "© «Кселл» АҚ 2000–2017. Қазақстан Республикасының Көлік және коммуникация " +
      "министрлігі 08.06.1998 берген мемлекеттік лицензия № ДС0000270, мерзімсіз.",
  },
  profileInfo: {
    ru: "Для изменения ФИО администратора и мобильного номера необходимо отправить заявку на фирменном бланке вашей компании на email@kcell.kz",
    en: "To edit Administrator's name and mobile number, please submit a request on your company letterhead to email@kcell.kz",
    kk: "Әкімшінің аты-жөні мен мобильді нөмірін өзгерту үшін email@kcell.kz адресіне компанияңыздың фирмалық бланкіндегі өтінімді жіберу қажет",
  },
  changePassword: {
    ru: "Смена пароля",
    en: "Change password",
    kk: "Құпия сөзді өзгерту",
  },
  editPassword: {
    ru: "Изменить пароль",
    en: "Change password",
    kk: "Құпия сөзді өзгерту",
  },
  newEmail: {
    ru: "Новый электронный адрес",
    en: "New e-mail",
    kk: "Жаңа e-mail",
  },
  changeEmail: {
    ru: "Смена электронного адреса",
    en: "Change e-mail",
    kk: "Электронды адресті өзгерту",
  },
  yourPassword: {
    ru: "Ваш пароль",
    en: "Your password",
    kk: "Сіздің құпия сөзіңіз",
  },
  enterPassword: {
    ru: "Введите пароль",
    en: "Enter password",
    kk: "Құпия сөзді енгізіңіз",
  },
  enterCurrentPassword: {
    ru: "Введите текущий пароль",
    en: "Enter current password",
    kk: "Ағымдағы құпия сөзді енгізіңіз",
  },
  enterNewPassword: {
    ru: "Введите новый пароль",
    en: "Enter new password",
    kk: "Жаңа құпия сөзді енгізіңіз",
  },
  yourNewPassword: {
    ru: "Ваш новый пароль",
    en: "Your new password",
    kk: "Сіздің жаңа құпия сөзіңіз",
  },
  repeatNewPassword: {
    ru: "Повторите ваш новый пароль",
    en: "Repeat your new password",
    kk: "Жаңа құпия сөзіңізді қайталаңыз",
  },
  change: {
    ru: "Изменить",
    en: "Change",
    kk: "Өзгерту",
  },
  companiesInfo: {
    ru: "Для удобства использования Кабинета в дальнейшем, Вы можете присвоить короткое название вашей компании (-ям)",
    en: "For convenient use of your mobile account, you can assign it a name that could a short name of you company.",
    kk: "Алдағы уақытта Кабинетті пайдаланудың қолайлы болуы үшін Сіз компания(лары)ңызға қысқартылған атау бере аласыз.",
  },
  save: {
    ru: "Сохранить",
    en: "Save",
    kk: "Сақтау",
  },
  bin: {
    ru: "БИН ",
    en: "BIN ",
    kk: "БСН ",
  },
  companyFullName: {
    ru: "Полное название компании",
    en: "Full company name",
    kk: "Компанияның толық атауы",
  },
  companyShortName: {
    ru: "Сокращенное название компании",
    en: "Short company name",
    kk: "Компанияның қысқартылған атауы ",
  },
  email_already_exist: {
    ru: "email уже существует",
    en: "email already exists",
    kk: "электрондық пошта әлдеқашан бар",
  },
  enterEmail: {
    ru: "введите email",
    en: "enter email",
    kk: "электрондық поштаны енгізіңіз",
  },
  invalid_password: {
    ru: "Неверный пароль",
    en: "Wrong password",
    kk: "құпия сөз дұрыс емес",
  },
  server_error: {
    ru: "Извините, сервис временно недоступен. Попробуйте повторить позднее.",
    en: "Sorry, service is temporarily unavailable. Please, try again later.",
    kk: "Кешіріңіз, сервис уақытша қолжетімсіз. Кейінірек қайталап көріңіз.",
  },
  enterAlias: {
    ru: "Введите краткое название",
    en: "Enter alias",
    kk: "Қысқа атауды енгізіңіз",
  },
  passwords_not_match: {
    ru: "Пароли не совпадают",
    en: "Passwords do not match",
    kk: "құпия сөздер сәйкес емес",
  },
  aliasApplied: {
    ru: "Краткое название успешно применено",
    en: "Alias successfully applied.",
    kk: "Қыска атауы сәтті қолданылды",
  },
  passwordApplied: {
    ru: "Пароль успешно изменен",
    en: "Password successfully changed",
    kk: "Құпия сөз сәтті өзгертілді",
  },
  emailChanged: {
    ru: "email успешно изменен",
    en: "email successfully changed",
    kk: "электронды пошта сәтті өзгертілді",
  },
  enabledServices: {
    ru: "Подключенные услуги",
    en: "Connected services",
    kk: "Қосылган қызметтер",
  },
  enabled: {
    ru: "Подключено",
    en: "Enabled",
    kk: "Қосылды",
  },
  disable: {
    ru: "Отключить",
    en: "Disable",
    kk: "Өшіру",
  },
  invalidEmail: {
    ru: "Некорректный email адрес",
    en: "Invalid email address",
    kk: "Дұрыс емес email мекенжайы",
  },
  otpSent: {
    ru: "Код подтверждения отправлен на ваш email",
    en: "Confirmation code sent to your email",
    kk: "Растау коды сіздің email-ға жіберілді",
  },
  enterOtp: {
    ru: "Введите код подтверждения",
    en: "Enter confirmation code",
    kk: "Растау кодын енгізіңіз",
  },
  otpIncorrect: {
    ru: "Неверный код подтверждения",
    en: "Incorrect confirmation code",
    kk: "Дұрыс емес растау коды",
  },
  tooManyOtpRequests: {
    ru: "Превышено максимальное количество запросов кода подтверждения. Повторно отправить код нельзя. Попробуйте позже.",
    en: "Maximum number of confirmation code requests exceeded. Cannot resend the code. Please try again later.",
    kk: "Растау кодын сұрау санының максимум шегінен асты. Кодты қайта жіберу мүмкін емес. Кейінірек қайталап көріңіз.",
  },
  resendOtp: {
    ru: "Повторно отправить код",
    en: "Resend code",
    kk: "Кодты қайта жіберу",
  },
  tooManyAttempts: {
    ru: "Слишком много попыток. Попробуйте позже",
    en: "Too many attempts. Try again later",
    kk: "Тым көп әрекет. Кейінірек қайталаңыз",
  },
  waitTime: {
    ru: "Повторная отправка кода будет доступна через",
    en: "Code resend will be available in",
    kk: "Кодты қайта жіберу мүмкін болады",
  },
  seconds: {
    ru: "сек",
    en: "sec",
    kk: "сек",
  },
  minutes: {
    ru: "мин",
    en: "min",
    kk: "мин",
  },
  sendOtp: {
    ru: "Отправить код",
    en: "Send code",
    kk: "Кодты жіберу",
  },
  confirmEmailChange: {
    ru: "Подтвердить смену email",
    en: "Confirm email change",
    kk: "Email өзгерісін растау",
  },

  passwordRequirements: {
    ru: "Пароль должен содержать минимум 8 символов (2 символа верхнего регистра, 2 символа нижнего регистра, 2 спец символа, 2 цифры)",
    en: "Password must be at least 8 characters (2 uppercase letters, 2 lowercase letters, 2 special characters, 2 digits).",
    kk: "Құпия сөз кемінде 8 таңбадан тұруы керек (2 бас әріп, 2 кіші әріп, 2 арнайы таңба, 2 сан).",
  },
  passwordsNotMatchDetailed: {
    ru: "Введенные пароли не совпадают. Попробуйте еще раз.",
    kk: "Енгізілген құпия сөздер сәйкес келмейді. Әрекетті қайталап көріңіз.",
    en: "Passwords don’t match. Please try again.",
  },
  passwordChangeSuccess: {
    ru: "Пароль успешно изменен",
    en: "Password successfully changed",
    kk: "Құпия сөз сәтті өзгертілді",
  },
  passwordInvalidByRequirements: {
    ru: "Новый пароль не соответствует требованиям. Попробуйте еще раз.",
    kk: "Жаңа құпия сөз талаптарға сәйкес келмейді. Әрекетті қайталап көріңіз.",
    en: "New password doesn't meet security requirements. Please try again.",
  },
  passwordWrongCurrent: {
    ru: "Неверный пароль",
    en: "Wrong password",
    kk: "Құпия сөз дұрыс емес",
  },
  serviceTemporarilyUnavailable: {
    ru: "Сервис временно недоступен",
    en: "Service is temporarily unavailable",
    kk: "Қызмет уақытша қолжетімсіз",
  },
  unknownError: {
    ru: "Произошла ошибка. Попробуйте позже.",
    en: "Something went wrong. Please try again later.",
    kk: "Қате орын алды. Кейінірек қайталап көріңіз.",
  },
};
